<template>
	<div id="zytemplate" :class="inputs ? 'active' : '' " @mouseenter="btn =true" @mouseleave="btn = false" @click.stop="enterDel">
		<div class="showData" v-show="!inputs"><p>{{zymsg}}</p></div>
		<el-autocomplete 
			ref="inputRef" v-show="inputs" 
			v-model.trim="zymsg" placeholder="请选择摘要"
			@keydown.enter.native = "enterSelect"
			@keydown.native = 'inputBlur2'
			@keydown.tab.native.prevent = "tabChanges"
			:popper-append-to-body="false"
			@select="inputBlur" @blur="inputBlurTip"
			@focus="selectAll"
			:fetch-suggestions="getFilterList"
		>
		</el-autocomplete>
		<div class="maskAux"></div>
	</div>
</template>

<script>
export default {
	props:['zyText','inputFocus','perv','zyList'],
	data(){
		return {
			btn:false,
			inputs:false,
			zymsg:'',
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			
		},
		enterDel(){
			let auxli = this.$store.state.loadstatus.auxliaryModal;
			if(auxli){
				this.$message.error('请选择辅助核算！');
				return false;
			};
			this.inputs = true;
			this.$nextTick(()=>{
				this.$refs.inputRef.focus();
				this.getSummarys();
			});
		},
		inputBlur2(){
			this.$store.commit('UPDATAVOUCHER',true);
			this.$store.commit('UPDATAVOUCHER_SUPER',false);
		},
		inputBlur(){
			this.$store.commit('UPDATAVOUCHER',true);
			this.$store.commit('UPDATAVOUCHER_SUPER',false);
			this.$emit('on-push-summary',this.zymsg);
			this.$nextTick(()=>{
				this.$refs.inputRef.close();
				this.inputs = false;
			});
		},
		inputBlurTip(){
			setTimeout(()=>{
				const _=this;
				_.inputs = false;
				_.$nextTick(()=>{
					_.$refs.inputRef.close();
				});
			},200);
		},
		getFilterList(val,callback){
			const _=this;
			var all = [];
			for(let i=0;i<_.zyList.length;i++){
				if(_.zyList[i].value.indexOf(val) != -1){
					all.push(_.zyList[i])
				}
			}
			callback(all);
		},
		enterSelect(){
			const _=this;
			if(_.zymsg == ''){
				_.zymsg = _.zyList[0].value;
			};
			_.$nextTick(()=>{
				_.$refs.inputRef.close();
				_.inputs = false;
			});
			_.$emit('on-enter-keyDown',true);
		},
		getSummarys(){
			const _=this;
			if(_.perv && _.perv != '' && _.zymsg == ''){
				_.zymsg = _.perv;
				this.$store.commit('UPDATAVOUCHER',true);
				this.$store.commit('UPDATAVOUCHER_SUPER',false);
			};
		},//tab事件控制
		tabChanges(val){
			const _=this;
			if(val.shiftKey){
				_.$emit('on-tab-focusChange',false);
			}else{
				_.$emit('on-tab-focusChange',true);
			}
		},//全选摘要内容
		selectAll(e){
			setTimeout(()=>{
				e.target.select();
			},20);
		},
	},
	mounted() {
		this.zymsg = this.zyText;
	},
	created(){
		
	},
	watch: {
		zyText(Val){
      console.log(Val);
			this.zymsg = Val;
		},
		zymsg(Val){
			this.$emit('on-push-summary',this.zymsg);
		},
		inputFocus:{
			handler(Val){
				const _=this;
				if(Val && Val.zyInputFocus){
					_.inputs = true;
					_.$nextTick(()=>{
						_.$refs.inputRef.focus();
						_.getSummarys();
					});
				}
			},
			deep:true,
			immediate:true,
		},
		perv(Val){////-----上一条摘要
		
		},
		zyList(val){
			
		},
	},
}
</script>

<style lang="less">
	#zytemplate{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding:0 5px;
		height: 100%;
		min-height: 55px;
		cursor: pointer;
		width: 100%;
		padding-right: 30px;
		position: relative;
		.showData{
			line-height: 22px;
			text-align: left;
			word-break: break-all;
			p{
				font-size: 14px;
				padding-left: 15px;
			}
		}
		&.active{
			background-color: #fff;
		}
		.el-input{
			font-size: 14px;
			padding-right: 15px;
			.el-input__inner{
				border:none;
				&:focus{
					border:none
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/table/zyTemplate.vue